import { slideUp, slideDown } from "./slide";

// Drawer Menu
export function drawerMenu() {
  const drawerToggle = document.querySelector(".js-drawer-toggle");
  const drawer = document.querySelector(".js-drawer");
  const html = document.querySelector("html");

  if (drawerToggle) {
    drawerToggle.addEventListener("click", function () {
      this.classList.toggle("is-active");
      drawer.classList.toggle("is-active");
      html.classList.toggle("is-scroll-prevent");
    });
  }
}
// Accordion
export function accordion() {
  const accordionTriggers = document.querySelectorAll(".js-acc-trigger");

  accordionTriggers.forEach((trigger) => {
    trigger.addEventListener("click", function () {
      this.classList.toggle("is-active");
      const content = this.nextElementSibling;

      if (content.classList.contains("js-acc-main")) {
        if (content.style.display === "block" || content.style.display === "") {
          slideUp(content);
        } else {
          slideDown(content);
        }
      }
    });
  });
}

// Smooth Scroll
export function smoothScroll() {
  const anchors = document.querySelectorAll('a[href^="#"]');

  anchors.forEach((anchor) => {
    anchor.addEventListener("click", function (e) {
      e.preventDefault();

      const speed = 800;
      const header = document.querySelector(".l-header");
      const headerHeight = header ? header.offsetHeight : 0;

      const href = this.getAttribute("href");
      const target =
        href === "#" || href === ""
          ? document.documentElement
          : document.querySelector(href);

      if (target) {
        const position =
          target.getBoundingClientRect().top +
          window.pageYOffset -
          headerHeight -
          20;

        // スムーズスクロールのアニメーション
        const startPosition = window.pageYOffset;
        const distance = position - startPosition;
        let startTime = null;

        function animation(currentTime) {
          if (startTime === null) startTime = currentTime;
          const timeElapsed = currentTime - startTime;
          const progress = Math.min(timeElapsed / speed, 1);
          const easeInOutCubic =
            progress < 0.5
              ? 4 * progress * progress * progress
              : 1 - Math.pow(-2 * progress + 2, 3) / 2;

          window.scrollTo(0, startPosition + distance * easeInOutCubic);

          if (timeElapsed < speed) {
            requestAnimationFrame(animation);
          }
        }

        requestAnimationFrame(animation);
      }

      return false;
    });
  });
}
